import React from "react";
import Text from "../text";
import SelectButton from "../selectButton";
import {
  DomainCardContainer,
  DescriptionContainer,
  BoutonContainer,
} from "./styled-components";

const DomainCard = ({
  title,
  description,
  color,
  isActive,
  onClick,
  disabled,
}: DomainCardProps) => {
  return (
    <DomainCardContainer
      color={color}
      disabled={disabled}
      onClick={onClick}
      isActive={isActive}
    >
      <DescriptionContainer>
        <Text size="20px" lineHeight="20px" weight={600}>
          {title}
        </Text>
        <Text color="grey400" weight={600}>
          {description}
        </Text>
      </DescriptionContainer>
      <BoutonContainer>
        <SelectButton
          onClick={onClick}
          isActive={isActive}
          isDisabled={disabled}
        />
      </BoutonContainer>
    </DomainCardContainer>
  );
};

export default DomainCard;
